import {RootStore, store} from "../../store/rootStore";
import React, {createContext} from "react";
import {App} from "./App";
import { ThemeProvider } from "../../hooks/useTheme";

export const StoreContext = createContext<RootStore>({} as RootStore)
export const AppContainer = () => {
    return (
        <ThemeProvider>
            <StoreContext.Provider value={store}>
                <App/>
            </StoreContext.Provider>
        </ThemeProvider>
    )
}